import Layout from "@/layout/main.vue";

export default {
  meta: {
    title: "首页",
    icon: "b-home",
  },
  // hide: true,
  path: "/home",
  component: Layout,
  children: [
    {
      path: "/home/index",
      name: "homeIndex",
      meta: {
        title: "工作台",
        auth: [],
      },
      component: () => import("@/views/home/index"),
    },
    {
      path: "/home/tisindex",
      name: "homeTisindex",
      meta: {
        title: "工作台",
        auth: [],
      },
      component: () => import("@/views/home/tisindex"),
    },
    {
      path: "/dashboard",
      name: "dashboard",
      meta: {
        title: "数据看板",
        auth: [],
      },
      component: () => import("@/views/screen/index"),
    },
    {
      path: "/screen/bxindex",
      name: "bxscreenIndex",
      component: () => import("@/views/bxscreen/index"),
      meta: {
        title: "数据看板",
        auth: [],
        img: "sjkb",
      },
    },
    {
      path: "/screen/zgindex",
      name: "zgscreenIndex",
      component: () => import("@/views/zgscreen/index"),
      meta: {
        title: "数据看板",
        auth: [],
      },
    },
  ],
};
